import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { useSelector } from "react-redux";

export function LoginModal({ show, onClose, onLoginSuccess, baseUrl }) {
    const [email, setEmailPhone] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate(); // <-- add this
    const client = useSelector((state) => state.client.client);
    const client_uid = client?.uid || "clnt_QI9Jd1m0"; // fallback to default if not available

    // Paste your VAPID public key here (base64 urlsafe)
    const VAPID_PUBLIC_KEY = 'BL1p6Elf7F9-UuePofmyrNqhN2G7j9fyLz5n1VDWMIxWn3Ptd6pBT-GSSi4corP1CT25rcm_TaMfVUSEoqYzoAs';

    const [status, setStatus] = useState('');

    function urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);
        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    useEffect(() => {
        async function askPermission() {
            const permission = await Notification.requestPermission();
            if (permission === "granted") {
                console.log("✅ Notifications allowed");
            } else {
                console.warn("🚫 Notifications not allowed:", permission);
            }
        }
        askPermission();
    }, []);

    // ESC key to close
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };
        if (show) window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [show, onClose]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        const formData = new FormData();
        formData.append("email", email);
        formData.append("password", password);
        formData.append("client_uid", client_uid);
        setStatus("Triggering push...");
        try {
            const response = await axios.post(baseUrl + "/login", formData);

            console.log("Login success:", response.data);
            setStatus('Push sent. Approve from your mobile browser.');

            // call parent callback
            if (typeof onLoginSuccess === "function") {
                onLoginSuccess(response.data.token, response.data.role, response.data.name); // pass token and role
            }

            onClose(); // close modal on success

            if (response.data.role === 'customer') {

                navigate("/customer/dashboard"); // <-- redirect on success


            }
            else navigate("/agent/dashboard"); // <-- redirect on success
        } catch (err) {
            console.error(err);
            setError(err.response?.data?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.div
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        transition={{ duration: 0.25 }}
                        onClick={(e) => e.stopPropagation()}
                        role="dialog"
                        aria-modal="true"
                        className="relative bg-white rounded-2xl shadow-xl w-full max-w-md p-6"
                    >
                        <button
                            onClick={onClose}
                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
                        >
                            ✕
                        </button>

                        <h2 className="text-xl font-bold mb-4">Logg inn</h2>
                        <form onSubmit={handleLogin} className="space-y-4">
                            <input
                                type="text"
                                placeholder="Email / Phone"
                                value={email}
                                onChange={(e) => setEmailPhone(e.target.value)}
                                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-1 focus:ring-purple-500 focus:border-purple-500"
                                required
                            />
                            <input
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-1 focus:ring-purple-500 focus:border-purple-500"
                                required
                            />

                            {error && <p className="text-sm text-red-600">{error}</p>}

                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full bg-purple-600 hover:bg-purple-700 text-white rounded-full px-4 py-2"
                            >

                                {loading ? "Logging in..." : "Logg inn"}
                            </button>
                            <button>Register device</button>
                        </form>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
